import { NgModule } from '@angular/core';
import { Routes } from '@angular/router';
// Pages
import { PageNotFoundComponent } from '.';

import { LoginComponent } from './pages/authorization/login/login.component';
import { RegisterComponent } from './pages/authorization/register/register.component';
import { SignUpComponent } from './pages/authorization/sign-up/sign-up.component';
import { AuthGuard } from './services/auth/auth.guard';
import { HtmlComponentsComponent } from './layout/html-components/html-components.component';
import { SchoolProfileComponent } from 'src/app/pages/producer/school-profile/school-profile.component';
import { PublicSchoolComponent } from './pages/common/public-school/public-school.component';
import { UnsuscribeEmailComponent } from './pages/common/unsuscribe-email/unsuscribe-email.component';
import { ForgotPasswordComponent } from './pages/authorization/forgot-password/forgot-password.component';
import { PasswordResetComponent } from './pages/authorization/password-reset/password-reset.component';
import { sign } from 'crypto';
import { SsoLoginComponent } from './pages/authorization/sso-login/sso-login.component';
import { permissionGuard } from './core/guards/permission.guard';
import { PERMISSION_GROUPS } from 'src/app/config/permission-groups';
import { PERMISSIONS } from './config/permissions.constants';

import { JobsComponent } from './pages/consumer';
import { JobDetailsComponent } from './pages/consumer/jobs/job-details/job-details.component';
import { JobsDomainRedirectGuard } from './services/auth/jobs-domain-redirect.guard';
// import { PortfolioComponent } from './pages/consumer/profile/portfolio/portfolio.component';
export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
    data: { title: 'Login | ClassCover' },
  },

  {
    path: 'login',
    data: { title: 'Login | ClassCover' },
    component: LoginComponent,
  },
  {
    path: 'switch-school',
    data: { title: 'Login | ClassCover' },
    component: LoginComponent,
  },
  {
    path: 'login-sso',
    data: { title: 'Login | ClassCover' },
    component: SsoLoginComponent,
  },
  {
    path: 'job-details/:id',
    data: { title: 'Public Jobs | ClassCover' },
    component: JobDetailsComponent,
    canActivate: [JobsDomainRedirectGuard],
  },
  {
    path: 'jobs',
    data: { title: 'Public Jobs | ClassCover' },
    component: JobsComponent,
    canActivate: [JobsDomainRedirectGuard],
  },
  {
    path: 'register',
    data: { title: 'Register | ClassCover' },
    pathMatch: 'full',
    component: RegisterComponent,
  }, {
    path: 'signup',
    data: { title: 'Signup | ClassCover' },
    pathMatch: 'full',
    component: SignUpComponent,
  },
  {
    path: 'reset-password/:slugName',
    data: { title: 'Reset Password | ClassCover' },
    pathMatch: 'full',
    component: PasswordResetComponent,
  },
  {
    path: 'forgot-password',
    data: { title: 'Forgot Password | ClassCover' },
    pathMatch: 'full',
    component: ForgotPasswordComponent,
  },
  {
    path: 'public-profile/:slugName',
    data: {
      title: 'school-profile',
    },
    component: PublicSchoolComponent,
    // canActivate: [AuthGuard, CheckSwitch]
  },
  {
    path: 'unsuscribe-email',
    data: {
      title: 'Unsuscribe-email',
      role: 'School',
    },
    component: UnsuscribeEmailComponent,
    // canActivate: [AuthGuard, CheckSwitch]
  },
  // Teacher portfolio route hidden for now
  // {
  //   path: 'portfolio/:username',
  //   component: PortfolioComponent,
  //   data: {
  //     title: 'Portfolio',
  //   },
  // },
  {
    path: 'school',
    loadChildren: () =>
      import('./pages/producer/producer-routing.module').then(
        (m) => m.ProducerRoutingModule
      ),
    // canMatch: [permissionGuard],
    // data: {
    //   permission: PERMISSION_GROUPS.BOOKING_FULL_ACCESS
    // }
  },
  {
    path: 'group',
    loadChildren: () =>
      import('./pages/group/group-school-routing.module').then(
        (m) => m.GroupRoutingModule
      ),
  },
  {
    path: 'teacher',
    loadChildren: () =>
      import('./pages/consumer/consumer-routing.module').then(
        (m) => m.ConsumerRoutingModule
      ),
  },
  // {
  //   path: 'teacher/jobs',
  //   loadChildren: () =>
  //     import('./pages/consumer/jobs/teacher-jobs-routing.module').then(
  //       (m) => m.TeacherJobsRoutingModule
  //     ),
  // },
  {
    path: 'co-ordinator',
    loadChildren: () =>
      import('./pages/co-ordinator/co-ordinator-routing.module').then(
        (m) => m.CoOrdinatorRoutingModule
      ),
  }, {
    path: 'tracer',
    loadChildren: () =>
      import('./pages/tracer/tracer-routing.module').then(
        (m) => m.TracerRoutingModule
      ),
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    canActivate: [],
  }
];
